import { BuilderConfig } from '../../types/Builder';
import { COLORS } from '../business-button/business-button.constants';

import BusinessHubImageBlock, { IMAGE_POSITION, IMAGE_POSITION_MOBILE, ImageBlockProps, THEME_CONTENT } from './business-hub-image-block';

export const BusinessHubImageBlockBuilderConfig = {
    name: 'Business Hub Image Block',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
        },
        {
            name: 'backgroundLinearGradient',
            type: 'string',
        },
        {
            name: 'heightContainer',
            type: 'number',
        },
        {
            name: 'paddingTopContainer',
            type: 'number',
        },
        {
            name: 'paddingBottomContainer',
            type: 'number',
        },

        {
            name: 'paddingTopContainerMobile',
            type: 'number',
        },
        {
            name: 'paddingBottomContainerMobile',
            type: 'number',
        },
        {
            name: 'backgroundContent',
            type: 'string',
            enum: Object.values(THEME_CONTENT),
            defaultValue: THEME_CONTENT.default,
        },
        {
            name: 'backgroundImage',
            type: 'object',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                },
                {
                    name: 'imageMobile',
                    type: 'file',
                },
                {
                    name: 'zIndex',
                    type: 'number',
                    defaultValue: 0,
                },
            ],
        },
        {
            name: 'image',
            type: 'object',
            subFields: [
                {
                    name: 'source',
                    type: 'file',
                },
                {
                    name: 'sourceMobile',
                    type: 'file',
                },
                {
                    name: 'maxWidth',
                    type: 'number',
                },
                {
                    name: 'maxWidthMobile',
                    type: 'number',
                },
                {
                    name: 'positionImage',
                    type: 'string',
                    enum: Object.values(IMAGE_POSITION),
                    defaultValue: IMAGE_POSITION.Left,
                },
                {
                    name: 'positionImageMobile',
                    type: 'string',
                    enum: Object.values(IMAGE_POSITION_MOBILE),
                    defaultValue: IMAGE_POSITION_MOBILE.TopMobile,
                },
            ],
        },

        {
            name: 'backgroundLoop',
            type: 'file',
        },
        {
            name: 'bottomBackgroundLoop',
            type: 'number',
        },
        {
            name: 'positionImageLoop',
            type: 'string',
            enum: ['top', 'bottom'],
        },
        {
            name: 'text',
            type: 'object',
            subFields: [
                {
                    name: 'title',
                    type: 'richText',
                },
                {
                    name: 'maxWidthTitleMobile',
                    type: 'number',
                },
                {
                    name: 'description',
                    type: 'richText',
                },
                {
                    name: 'maxWidthDescription',
                    type: 'number',
                },
                {
                    name: 'ctaText',
                    type: 'string',
                },
                {
                    name: 'ctaLink',
                    type: 'string',
                },
                {
                    name: 'backgroundButton',
                    type: 'string',
                    enum: Object.values(COLORS),
                    defaultValue: COLORS.BLACK,
                },
                {
                    name: 'fillColor',
                    type: 'color',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<ImageBlockProps> = {
    component: BusinessHubImageBlock,
    config: BusinessHubImageBlockBuilderConfig,
};

export default builderConfig;
